import Const from '../util/Constants';
import config from '../config/config';

class LoginAPI {

  static headers = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'client': 'WebClient'
  }
  
  static login = (username, password, success, failure, logout) => {
    const body = JSON.stringify({ username, password });
    fetch(config.url, { method: 'POST', headers: LoginAPI.headers, body })
    .then(res => Const.ProcessAPI(res, success, failure, logout))
    .catch(er => failure(er));
  }

  static registrationOtp = (registration, success, failure) => {
    const body = JSON.stringify(registration);
    fetch(config.registration_otp, { method: 'POST', headers: LoginAPI.headers, body })
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static registration = (registration, success, failure) => {
    const body = JSON.stringify(registration);
    fetch(config.registration, { method: 'POST', headers: LoginAPI.headers, body })
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static deleteAccount = (account, success, failure) => {
    const body = JSON.stringify(account);
    fetch(config.delete, { method: 'POST', headers: LoginAPI.headers, body })
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static resetPassword = (email, success, failure) => {
    const body = JSON.stringify({email})
    fetch(config.reset_password, { method: 'POST', headers: LoginAPI.headers, body })
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static changePassword = (token, newPassword, success, failure) => {
    const body = JSON.stringify({ newPassword })
    fetch(`${config.reset_password}/${token}`, { method: 'POST', headers: LoginAPI.headers, body })
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  } 
}
export default LoginAPI;